export enum Application {
    ADDRESS_BOOK = 'address_book',
    ADMIN = 'admin',
    ANALYTICS = 'analytics',
    AUTHENTICATION = 'authentication',
    AUTHORIZATION = 'authorization',
    BUDGETS = 'budgets',
    CATALOGUE = 'catalogue',
    CONSTRAINTS = 'constraints',
    HARDWARE = 'hardware',
    ITSME = 'itsme',
    LAUNDRY = 'laundry',
    LENDING = 'lending',
    MONITORING = 'monitoring',
    NIVALIZ = 'nivaliz',
    NOTIFICATIONS = 'notifications',
    ORGANIZATION = 'organization',
    PUDO = 'pudo',
    REQUIREMENTS = 'requirements',
    SHOP = 'shop',
    SPOTS = 'spots',
    USERS = 'users',
    VENDING = 'vending'
}

export enum Feature {
    ACCESS_CONTROLLERS = 'access_controllers',
    ADMIN = 'admin',
    ATTRIBUTES = 'attributes',
    AUDIT_TRANSACTION = 'audit_transaction',
    BUDGETS = 'budgets',
    BULK_MOVE_TRANSACTION = 'bulk_move_transaction',
    KITS = 'kits',
    CATEGORIES = 'categories',
    CERTIFICATES = 'certificates',
    COLLIS = 'collis',
    CONSTRAINTS = 'constraints',
    CONTACTS = 'contacts',
    CONTENTS = 'contents',
    DASHBOARD = 'dashboard',
    DECEASED = 'deceased',
    EQUIPMENTS = 'equipments',
    FABLAB = 'fablab',
    GATES = 'gates',
    GROUPS = 'groups',
    INBOUND_TRANSACTION = 'inbound_transaction',
    INFRASTRUCTURE = 'infrastructure',
    INSIGHTS = 'insights',
    INVENTORY = 'inventory',
    INVITES = 'invites',
    LABELS = 'labels',
    LAYOUT = 'layout',
    LOCATIONS = 'locations',
    MAINTENANCE_TRANSACTION = 'maintenance_transaction',
    MANAGE = 'manage',
    MODULES = 'modules',
    MOVE_TRANSACTION = 'move_transaction',
    NOTIFICATIONS = 'notifications',
    OPEN_DROP_OFF = 'open_drop_off',
    ORDERS = 'orders',
    ORDER_TRANSACTION = 'order_transaction',
    OUTBOUND_TRANSACTION = 'outbound_transaction',
    PERMISSIONS = 'permissions',
    PRINT_LABELS = 'print_labels',
    PRODUCTS = 'products',
    QR_CODE = 'qr_code',
    RECYCLE_TRANSACTION = 'recycle_transaction',
    REPORTS = 'reports',
    REQUIREMENTS = 'requirements',
    RETURN_TRANSACTION = 'return_transaction',
    REVIEW = 'review',
    REVIEWS = 'reviews',
    ROLES = 'roles',
    SCANNER = 'scanner',
    SCHEDULES = 'schedules',
    SLOTS = 'slots',
    SPOTS = 'spots',
    STOCK = 'stock',
    TEMPLATES = 'templates',
    TRANSACTIONS = 'transactions',
    TRANSACTIONS_COLLIS = 'transactions_collis',
    USER_GROUPS = 'user_groups',
    USES = 'uses',
    USERS = 'users'
}

export enum FeatureTarget {
    MOBILE = 'mobile',
    PLATFORM = 'platform',
    TERMINAL = 'terminal',

    // Not known by backend
    API = 'api',
    KIOSK = 'kiosk'
}

export enum FunctionalityType {
    CORPORATE = 'corporate',
    PERSONAL = 'personal'
}
